import React from "react";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav
  // NavItem,
  // NavLink
  // UncontrolledDropdown,
  // DropdownToggle,
  // DropdownMenu,
  // DropdownItem
} from "reactstrap";

export default class Example extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
  }
  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }
  render() {
    return (
      <div>
        <Navbar color="light" light expand="md">
          <NavbarBrand href="/">
            <img
              src={require("../../images/logo.png")}
              style={{ height: "50px" }}
              alt="OrganizeMate-logo"
            />
          </NavbarBrand>
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className="ml-auto" navbar>
              {/* <NavItem>
                <NavLink href="/port">port</NavLink>
              </NavItem> */}
{/*              <button className="btn btn-outline-info" type="submit">
                Sign in
              </button>
*/}
            </Nav>
          </Collapse>
        </Navbar>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Navbar/Navbar.js